import * as React from 'react';
;
/**
 * Represents a React Context which provides you with the option to configure the KendoReact components icons.
 */
export var IconsContext = /*#__PURE__*/React.createContext({
  type: 'svg'
});
IconsContext.displayName = 'KendoReactIconsContext';